import React from 'react';
import { List } from 'antd';

import JobDescriptionCard from './job-description-card';
import { JobListItem } from '../styles';
import { SkeletonList } from '../../skeleton-list/skeleton-list';

export default function JobDescriptionList({
	jobs,
	companyLocation,
	companyLogo,
	fakeItemsCount,
	loading,
	withSkeleton = true
}: any) {
	let list = (
		<List
			dataSource={jobs || []}
			itemLayout="vertical"
			size="default"
			renderItem={(job: any) => (
				<JobListItem key={job._id} style={{ border: 'none', padding: '0' }}>
					<JobDescriptionCard job={job} companyLocation={companyLocation} companyLogo={companyLogo} />
				</JobListItem>
			)}
		/>
	);
	if (withSkeleton && loading) list = <SkeletonList itemsCount={fakeItemsCount || 5} />;
	return list;
}
